export const CART_KEY = 'alejo_cart';
export const TOTAL_KEY = 'alejo_total';
export const TOTAL_PRICE_KEY = 'alejo_total_price';
